"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgCursor01 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.143 2.81c-.25-.105-.497-.207-.702-.272-.183-.058-.565-.17-.975-.036a1.5 1.5 0 0 0-.965.964c-.133.41-.022.792.036.975.065.205.168.452.273.703l5.537 13.29c.113.273.222.534.327.735.09.17.29.541.696.737a1.5 1.5 0 0 0 1.394-.047c.392-.223.567-.606.645-.782.09-.207.182-.476.277-.755l1.324-3.898 5.283 5.283a1 1 0 0 0 1.414-1.414l-5.283-5.283 3.898-1.324c.279-.095.547-.186.755-.277.176-.077.56-.253.782-.644a1.5 1.5 0 0 0 .047-1.395c-.196-.406-.566-.607-.737-.696-.2-.105-.463-.214-.735-.327L5.144 2.81Z", fill: "currentColor" }) }))); };
exports.default = SvgCursor01;
